<template>
  <li class="pro_list_item">
    <router-link :to="'/pro_detail?id='+objItem.id" target="_blank">
      <div class="pro_list_item_t">
        <img :src="objItem.cover_thumbnail" alt />
      </div>
      <div class="pro_list_item_b">
        <div class="pro_list_item_b_t">
          <h3>{{objItem.name}}</h3>
          <h4>{{objItem.school_name}}</h4>
          <div class="pro_list_item_b_icon">
          <span>
            <i class="icon_eay"></i>{{objItem.popularity || 0}}
          </span>
            <span>
            <i class="icon_xin"></i>{{objItem.like_count || 0}}
          </span>
<!--            <span>-->
<!--            <i class="icon_share"></i>{{objItem.like_count || 0}}-->
<!--          </span>-->
          </div>
        </div>
        <div class="pro_list_item_b_b">
          <img :src="objItem.designer_headPath"/>
          <span>{{objItem.student_name || objItem.designer_name}}</span>
        </div>
      </div>
    </router-link>

  </li>
</template>

<script>
export default {
  props:{
    objItem: Object
  }
};
</script>

<style lang="scss" scoped>
.pro_list_item {
  width: 285px;
  margin: 0 20px 20px 0;
  a{
    display: block;
  }
  .pro_list_item_t {
    height: 212px;
    background: #f0f0f0;
    img {
      width: 285px;
      height: 212px;
      object-fit: contain;
    }
  }
  .pro_list_item_b {
    padding: 13px 20px 0;
    background: #fff;
    .pro_list_item_b_t {
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      h3 {
        font-size: 16px;
        color: #333;
        height: 35px;
        line-height: 35px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      h4 {
        font-size: 14px;
        color: #999;
        height: 20px;
        line-height: 20px;
      }
      .pro_list_item_b_icon {
        display: flex;
        height: 52px;
        align-items: center;
        span {
          display: flex;
          font-size: 12px;
          color: #aaa;
          align-items: center;
          i {
            margin-right: 6px;
          }
        }
        span + span {
          margin-left: 20px;
        }
      }
    }
    .pro_list_item_b_b {
      height: 46px;
      display: flex;
      align-items: center;
      img{
        width: 24px;
        height: 24px;
        border-radius: 50%;

      }
      span{
        color: #333333;
        font-size: 14px;
        padding-left: 10px;
      }
    }
  }
}
</style>
